module.exports = __webpack_public_path__ + "img/Outdoor.6b90501.png";